import {Component, Host, OnInit} from '@angular/core';
import {AbstractView} from '../abstract-view.class';
import {DirectoryItemComponent} from '../directory-item.component';
import {ApiPetsItemService} from '../../../services/api-directory.service';

@Component({
    templateUrl: 'pets.template.html',
    providers: [ApiPetsItemService]
})
export class PetsComponent extends AbstractView implements OnInit {
    title = 'Pet';
    protected petsList: Array<any>;

    constructor(@Host() parent: DirectoryItemComponent,
                public api: ApiPetsItemService) {
        super(parent, api);

        this.getPetTypes();
    }

    ngOnInit() {
        if(Object.keys(this.parent.directoryService.urlService.queryParams).length < 1)
            this.parent.directoryService.urlService.queryParams = this.parent.directoryService.urlService.getQueryParamsJson();

        const urlTree = this.parent.router.createUrlTree(
            [],
            {queryParams: this.parent.directoryService.urlService.queryParams, skipLocationChange: true});
        this.parent.router.navigateByUrl(urlTree);

        super.ngOnInit();
    }

    private getPetTypes() {
        this.api.getPetTypes().subscribe((res) => {
            this.petsList = res.entities;
        });
    }

}



// WEBPACK FOOTER //
// /app/src/app/views/directory-item/pets/pets.component.ts